import React from 'react'

const ScopeList = ({ scopes }) => (
    <div>
      <ul className="external-integration-install-modal-scopes">
        {scopes.map((scope, index) => (
            <li key={index} >
                { scope.description }
            </li>
        ))}
      </ul>
    </div>
)

export default ScopeList
